// extracted by mini-css-extract-plugin
export default {"address2":"display_address2__-5tgN"};